import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { stockHistoryActions } from '../actions/stock-history.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class StockHistoryEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getHistory$ = createEffect(() => {
        return this.actions.pipe(
            ofType(stockHistoryActions.getHistory),
            switchMap(({ mode, value }) => {
                return this.httpService.getHistory(mode, value).pipe(
                    map((payload) => stockHistoryActions.getHistorySuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(stockHistoryActions.getHistoryError({ code: response.status }))),
                );
            }),
        );
    });
}
